import { render, staticRenderFns } from "./class_join.vue?vue&type=template&id=77432aaa&"
import script from "./class_join.vue?vue&type=script&lang=js&"
export * from "./class_join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports